import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../ApiConfig';
import style from '../../../css/admin/Uploadform.module.css';
import { showCustomAlerterror } from '../../customalert';
import { useNavigate } from 'react-router-dom';
import { getSecureToken } from '../../ApisService/apiService';

const UploadCommunityPage = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [imageFiles, setImageFiles] = useState([]);
  const [docFiles, setDocFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [speed, setSpeed] = useState(0);
  const [online, setOnline] = useState(navigator.onLine);
  const [message, setMessage] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const isAdmin = localStorage.getItem('islogin');
    if (!isAdmin || isAdmin !== 'true') {
      navigate('/admin');
    }
  }, []);

  useEffect(() => {
    const checkSession = async () => {
      const { secrettoken, ts } = await getSecureToken();
      try {
        const res = await axios.get(`${API_BASE_URL}adminauth/check_admin_session.php`, {
          headers: {
            'X-TOKEN': secrettoken,
            'X-TIMESTAMP': ts,
          },
          withCredentials: true,
        });

        console.log(res.data);

        if (res.data.status !== "ok") {
          navigate('/admin');
        }

      } catch (error) {
        console.error("Session check failed", error.response?.data || error.message);
        navigate('/admin');
      }
    };

    checkSession();
  }, []);


  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleFileChange = (event, setFiles, maxFiles) => {
    const selected = Array.from(event.target.files).slice(0, maxFiles);
    setFiles(selected);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const totalFiles = imageFiles.length + docFiles.length;
    const MAX_TOTAL_FILES = 10;

    if (totalFiles > MAX_TOTAL_FILES) {
      showCustomAlerterror(`You can only upload up to ${MAX_TOTAL_FILES} files in total.`);
      return;
    }

    setUploading(true);
    setMessage('');
    setProgress(0);
    setSpeed(0);

    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    imageFiles.forEach(file => formData.append('images[]', file));
    docFiles.forEach(file => formData.append('documents[]', file));

    const startTime = Date.now();
    const { secrettoken, ts } = await getSecureToken();

    try {
      await axios.post(`${API_BASE_URL}Community/community_upload.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', 'X-TOKEN': secrettoken,
          'X-TIMESTAMP': ts
        },
        withCredentials: true,
        onUploadProgress: (event) => {
          const percent = Math.round((event.loaded * 100) / event.total);
          const elapsed = (Date.now() - startTime) / 1000;
          const kbps = (event.loaded / 1024 / elapsed).toFixed(2);
          setProgress(percent);
          setSpeed(kbps);
        }
      });

      setMessage('Upload successful!');
      setTitle('');
      setDescription('');
      setImageFiles([]);
      setDocFiles([]);
      document.querySelectorAll("input[type='file']").forEach(input => (input.value = ''));
    } catch (err) {
      setMessage('Upload failed. Please try again.');
      showCustomAlerterror('Upload failed. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className={style.pageWrapper}>
      <h2 className={style.header}>Upload Community</h2>

      <div className={style.formContainer}>
        <form onSubmit={handleSubmit} className={style.uploadForm}>
          <label>Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter workshop title"
            required
          />

          <label>Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter description"
          ></textarea>

          <label>Upload Images (Max: 5)</label>
          <input
            type="file"
            accept=".jpg,.jpeg,.png"
            multiple
            onChange={(e) => handleFileChange(e, setImageFiles, 5)}
          />

          <label>Upload Documents (Max: 5)</label>
          <input
            type="file"
            accept=".pdf,.doc,.docx,.xls,.xlsx"
            multiple
            onChange={(e) => handleFileChange(e, setDocFiles, 5)}
          />

          <button type="submit" className={style.uploadButton} disabled={uploading}>
            {uploading ? 'Uploading...' : 'Save'}
          </button>
        </form>

        {uploading && (
          <div className={style.progressWrapper}>
            <p>Uploading: {progress}%</p>
            <div className={style.progressBar}>
              <div className={style.progress} style={{ width: `${progress}%` }}></div>
            </div>
            <p>Speed: {speed} KB/s</p>
          </div>
        )}

        <p className={style.message}>
          Internet: <span style={{ color: online ? 'green' : 'red' }}>{online ? 'Online' : 'Offline'}</span>
        </p>

        {message && <p className={style.message}>{message}</p>}
      </div>

      <a className={style.goBack} href="/admin_dash/communitygroup_upload">← Go Back</a>
    </div>
  );
};

export default UploadCommunityPage;
